import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  line-height: 20px;\n  color: ', ';\n  margin-right: 12px;\n  float: left;\n  width: 16px;\n  height: 20px;\n  display: block;\n  line-height: 20px;\n'], ['\n  display: block;\n  line-height: 20px;\n  color: ', ';\n  margin-right: 12px;\n  float: left;\n  width: 16px;\n  height: 20px;\n  display: block;\n  line-height: 20px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: block;\n  line-height: 20px;\n  color: ', ';\n'], ['\n  display: block;\n  line-height: 20px;\n  color: ', ';\n']);

import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../..';
import { styles, utils } from 'gipsy-misc';
import Field from '../../components/Field';

var UrlInfo = function UrlInfo(_ref) {
  var isActive = _ref.isActive,
      value = _ref.value;

  if (!value) {
    return '';
  }
  return React.createElement(
    Field,
    {
      style: { marginBottom: 20 },
      className: 'url-info-field' + (isActive ? ' active' : ''),
      onClick: utils.DOM.stopPropagation },
    React.createElement(
      'div',
      { className: 'row' },
      value.type === 'email' && React.createElement(StyledIcon, { icon: 'Mail' }),
      value.type === 'website' && React.createElement(StyledIcon, { icon: 'Link' }),
      value.type === 'slackMessage' && React.createElement(StyledIcon, { icon: 'Slack' }),
      React.createElement(
        Link,
        { target: '_blank', href: value.url },
        value.subject
      )
    )
  );
};

export default UrlInfo;

var StyledIcon = styled(Icon)(_templateObject, styles.colors.textLightColor);

var Link = styled.a(_templateObject2, styles.colors.textLightColor);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/UrlInfo/index.js
// module id = 504
// module chunks = 0